if (!customElements.get("bundle-product")) {
  customElements.define(
    "bundle-product",
    class BundleProduct extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;
        this.variantId = this.dataset.firstAvailableVariantId;
        this.sideCart = document.querySelector("side-cart");
        this.init();
      }

      init() {
        this.querySelector("button").addEventListener(
          "click",
          this.addBundleProd.bind(this)
        );
      }

      async addBundleProd() {
        if (!this.variantId) return;

        const fetchClassicBoxV2Information = async (boxParentProductId) => {
          try {
            const response = await fetch(
              "https://api.skio.com/storefront-http/get-classic-box-v2",
              {
                method: "POST",
                body: JSON.stringify({
                  productVariantPlatformId: boxParentProductId,
                }),
              }
            );
            if (!response.ok) {
              throw new Error("Failed to get box");
            }
            const { ClassicBoxV2 } = await response.json();
            console.log(`Box added.`);
            return ClassicBoxV2;
          } catch (error) {
            console.error(`${error}. Attempting to add single item.`);

            // if it's not a bundle, try to add it as a single line item
            try {
              await this.sideCart.addToCart(this.variantId);
              console.log(`Single item added.`);
            } catch (error) {
              console.error(error);
              throw error;
            }
          }
        };

        try {
          this.classList.add("inprogress");

          // skio bundles code edit
          // Fetch Classic Box V2 information
          const classicBoxV2 = await fetchClassicBoxV2Information(
            this.variantId
          );

          // Construct properties object
          const properties = {
            _isClassicBoxV2: true,
          };

          // Loop through selectableProductVariants and add to properties
          classicBoxV2.selectableProductVariants.forEach((item) => {
            properties[`_pv${item.platformId}`] = 1;
          });

          await this.sideCart.addToCart(
            this.variantId,
            undefined,
            null,
            properties
          );
          // skio bundles code edit

          setTimeout(this.classList.remove("inprogress"), 1000);
        } catch (err) {
          console.error(err);
        }
      }
    }
  );
}

// if (!customElements.get("bundle-product")) {
//   customElements.define(
//     "bundle-product",
//     class BundleProduct extends HTMLElement {
//       constructor() {
//         super();

//         this.productId = this.dataset.productId;
//         this.variantId = this.dataset.firstAvailableVariantId;
//         this.sideCart = document.querySelector("side-cart");
//         this.init();
//       }

//       init() {
//         this.querySelector("button").addEventListener("click", this.addBundleProd.bind(this));
//       }

//       async addBundleProd() {
//         if (!this.variantId) return;

//         try {
//           this.classList.add("inprogress");
//           await this.sideCart.addToCart(this.variantId);
//           setTimeout(this.classList.remove("inprogress"), 1000);
//         } catch (err) {
//           console.error(err);
//         }
//       }
//     }
//   );
// }
